/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import "./AnalyzesPage.scss";
import {
  Banner,
  Button,
  DashboardTopBar,
  DashboardTopPortal,
  EmptyState,
  PageHead,
} from "shared";

import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetMe } from "hooks/auth";
import { PACKET_ENUM, ROLES_ENUM, ROUTE_ENUM, SVG_ENUM } from "enums";

import { AnalyzeType } from "types/AnalyzeTypes";
import { useGetAnalyze } from "hooks/analyzes";
import AnalyzesTable from "features/analyzes/AnalyzesTable/AnalyzesTable";
import { AddAnalyzeModal, AnalyzeInfoModal } from "features/analyzes";
import { PacketModal } from "features/users";
import { isDesktop } from "utils";

export type AnalyzesTabsType = "all" | "completed" | "my" | "canceled";

const AnalyzesPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const linkPage = searchParams.get("page");
  interface ModalManage {
    type: string;
    analyze: AnalyzeType | null;
  }

  const [modalManage, setModalManage] = useState<ModalManage>({
    type: "",
    analyze: null,
  });
  const [page, setPage] = useState(Number(linkPage) || 1);
  const navigate = useNavigate();
  const { data: authorizedUser } = useGetMe();
  const [tab, setTab] = useState<AnalyzesTabsType>(
    authorizedUser?.role === ROLES_ENUM.USER ? "my" : "all",
  );
  const isAdmin = authorizedUser?.role === ROLES_ENUM.ADMIN;

  const { data, refetch } = useGetAnalyze({
    page,
    isAdmin: isAdmin,
    status: tab === "all" ? undefined : tab,
  });

  useEffect(() => {
    if (!isAdmin && authorizedUser?.package === PACKET_ENUM.PRO) {
      refetch();
    }
  }, [authorizedUser?.package]);

  const handleChangeTab = (item: AnalyzesTabsType) => {
    setTab(item);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set("page", "1");
    newSearchParams.set("tab", item);
    setSearchParams(newSearchParams);
  };

  const cleanModalManage = () => {
    setModalManage({ type: "", analyze: null });
    navigate(ROUTE_ENUM.ANALYSIS);
  };

  const openMeetingBooking = () => {
    window.open(
      "https://reliance.pro/inwestycje/#konsultacja-inwestycje",
      "_blank",
      "noopener,noreferrer",
    );
  };

  useEffect(() => {
    const params = document.location.search;
    const uuid = params.split("&")[0].split("=")[1];
    if (uuid) {
      const analyze = data?.data.find((item) => item.uuid === uuid);
      if (analyze) {
        setModalManage({ type: "companyInfo", analyze: analyze });
      }
    }
  }, [data?.data]);

  return (
    <>
      <PageHead
        title="Zleć analizę rynkową spółki | App Reliance Pro"
        description="Zamów szczegółową analizę wybranej spółki. Dopasowane informacje wspierające świadome decyzje inwestycyjne."
      />
      <PacketModal
        isOpen={modalManage.type === "packet"}
        onClose={cleanModalManage}
        parent="payment"
      />

      <AddAnalyzeModal
        user={authorizedUser}
        planChangeInitiatedAt={data?.planChangeInitiatedAt}
        isOpen={modalManage.type === "addAnalyze"}
        onClose={() => cleanModalManage()}
      />
      <AnalyzeInfoModal
        isOpen={modalManage.type === "companyInfo"}
        onClose={() => cleanModalManage()}
        analyze={modalManage.analyze}
      />
      <div className="companies analyzes">
        <DashboardTopBar>
          <h1 className="dashboard__header">Analizy rynkowe</h1>
          <div className="companies__buttons">
            {!isAdmin &&
            authorizedUser?.package === PACKET_ENUM.PRO &&
            isDesktop() ? (
              <>
                <Button
                  onClick={openMeetingBooking}
                  className="button-appointment dashboard__top-button button--rounded button--hide-on-mobile button--transparent companies__meeting"
                  label="Umów spotkanie"
                  svg={SVG_ENUM.CALENDAR}
                />

                <Button
                  className="dashboard__top-button button--rounded"
                  onClick={() =>
                    setModalManage({ type: "addAnalyze", analyze: null })
                  }
                  label="Zleć analizę spółki"
                />
              </>
            ) : null}
          </div>
        </DashboardTopBar>
        <div className="dashboard-content__wrapper">
          <div className="dashboard-content">
            <DashboardTopPortal>
              <div className="dashboard__tabs">
                {authorizedUser?.role === ROLES_ENUM.ADMIN ? (
                  <>
                    <span
                      onClick={() => handleChangeTab("all")}
                      className={`dashboard__tab ${
                        tab === "all" ? "dashboard__tab--active" : ""
                      } `}
                    >
                      Wszystkie wnioski
                    </span>
                    <span
                      onClick={() => handleChangeTab("completed")}
                      className={`dashboard__tab ${
                        tab === "completed" ? "dashboard__tab--active" : ""
                      } `}
                    >
                      Wykonane analizy
                    </span>
                    <span
                      onClick={() => handleChangeTab("canceled")}
                      className={`dashboard__tab ${
                        tab === "canceled" ? "dashboard__tab--active" : ""
                      } `}
                    >
                      Odrzucone wnioski
                    </span>
                  </>
                ) : null}
              </div>
            </DashboardTopPortal>
            {!isAdmin &&
              authorizedUser?.package === PACKET_ENUM.PRO &&
              !isDesktop() && (
                <Button
                  className="dashboard__top-button button--rounded analyzes__button"
                  styleType="primary"
                  onClick={() =>
                    setModalManage({ type: "addAnalyze", analyze: null })
                  }
                  label="Zleć analizę spółki"
                />
              )}

            {data?.data.length ? (
              <AnalyzesTable
                page={page}
                setPage={setPage}
                tab={tab}
                setModalManage={setModalManage}
                data={data}
                onRowClick={(analyze: AnalyzeType, e: any) =>
                  setModalManage({ type: "companyInfo", analyze: analyze })
                }
              />
            ) : !isAdmin && authorizedUser?.package === PACKET_ENUM.PRO ? (
              <EmptyState
                svg={SVG_ENUM.INFO}
                text={
                  <p>
                    W tym miejscu pojawi się lista zleconych analiz rynkowych.
                    Aby zlecić analizę, kliknij w&nbsp;przycisk “zleć analizę
                    rynkową”.
                  </p>
                }
              />
            ) : !!authorizedUser?.package ? (
              <Banner
                className="banner__top-64"
                text={
                  <p>
                    Analizy rynkowe nie są dostępne w obecnym pakiecie. Aby
                    odblokować dostęp <b>należy zakupić wyższy pakiet.</b>
                  </p>
                }
                buttonLabel="Zmiana pakietu"
                buttonOnClick={() =>
                  setModalManage({ type: "packet", analyze: null })
                }
              />
            ) : (
              !isAdmin && (
                <Banner
                  className="banner__top-64 banner__image--2"
                  text={
                    <p>
                      Analizy rynkowe są dostępne{" "}
                      <b>wyłącznie dla użytkowników z aktywnym pakietem PRO</b>.{" "}
                      <br />
                      Zwiększ pakiet, by odblokować dostęp.
                    </p>
                  }
                  buttonLabel="Sprawdź dostępne pakiety"
                  bannerImage="Banner.webp"
                  buttonOnClick={() =>
                    setModalManage({ type: "packet", analyze: null })
                  }
                />
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AnalyzesPage;
